/* Theme editor lifecycle only. Storefront behavior stays in the original assets. */
(() => {
  if (!window.Shopify?.designMode) return;
  const loaded = new Set([...document.scripts].filter(s => s.src).map(s => s.src));
  document.addEventListener('shopify:section:load', async event => {
    const root = event.target;
    let addedAsset = false;
    for (const old of root.querySelectorAll('script[src]')) {
      if (loaded.has(old.src)) continue;
      loaded.add(old.src);
      const script = document.createElement('script');
      script.src = old.src;
      script.async = false;
      await new Promise(resolve => { script.onload = script.onerror = resolve; document.head.appendChild(script); });
      addedAsset = true;
    }
    // Inline marquees use section-specific IDs; rerun only these local scripts.
    for (const old of root.querySelectorAll('script:not([src])')) {
      if (old.type && !['text/javascript','application/javascript'].includes(old.type)) continue;
      const script = document.createElement('script');
      script.textContent = old.textContent;
      old.replaceWith(script);
    }
    window.MXAmbassadorsInit?.(root);
    window.MXStickyRefresh?.();
    // New assets register their existing Shopify section handlers after this event.
    if (addedAsset) root.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles:true}));
  });
  document.addEventListener('shopify:block:select', event => {
    const node = event.target;
    const slide = node.closest('[data-pv-slide]');
    if (slide) document.querySelector('[data-pv-thumb="'+slide.dataset.pvSlide+'"]')?.click();
    const faq = node.closest('details');
    if (faq) faq.open = true;
    node.scrollIntoView?.({behavior:'smooth',block:'center'});
  });
})();
